import { render, staticRenderFns } from "./AddTwoImage.vue?vue&type=template&id=8a56d5d2&scoped=true&"
import script from "./AddTwoImage.vue?vue&type=script&lang=js&"
export * from "./AddTwoImage.vue?vue&type=script&lang=js&"
import style0 from "./AddTwoImage.vue?vue&type=style&index=0&id=8a56d5d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a56d5d2",
  null
  
)

export default component.exports